/**
 * beszélget a fiakkal
 * @author sarkiroka on 2017.09.18.
 */
import axios from 'axios';

export default {
	search(address) {
		const data = {
			language: 'hu',
			type: 'FIOK',
			fiokSzolgaltatasTipus: 'lak'
		};
		if (typeof address == 'string') {
			data.address = address;
		} else {
			data.latitude = address.lat;
			data.longitude = address.lng;
		}
		return axios.post('/fiak/searchLak', data);
	}
};
